import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BsArrowBarLeft } from "react-icons/bs";
import { setOpen } from "../../redux/user/user.actions";
import { setOpenFb } from "../../firebase/firebase.utils";
import Stations from "../../components/stations/stations.component";
import "./station.syles.scss";

export default function Station() {
  const uid = useSelector((s) => s.user.currentUser?.uid);
  const open = useSelector((s) => s.user.currentUser?.open);
  const dispatch = useDispatch();
  const toggle = () => {
    dispatch(setOpen(!open));
    setOpenFb(uid, open);
  };
  return (
    <motion.div
      className="station"
      animate={{ marginLeft: open ? 0 : "-183px" }}
      transition={{ ease: "easeOut" }}
    >
      <div className="allHome">
        <Link to="https://www.antlogy.com/" className="homeIconAll">
          <img
            className="antLogy__logo"
            src="/antlogy_logo.png"
            height="36px"
            alt="Antlogy"
            style={{ objectFit: "cover" }}
          />
        </Link>
      </div>
      <motion.div
        className="station__hide"
        animate={{ y: open ? 0 : -27, x: 0, rotate: open ? 0 : 180 }}
        transition={{ times: [0, 0.1, 0.9, 1], duration: 0.3 }}
        role="button"
        tabIndex={0}
        aria-label="Toggle project sidebar"
        aria-expanded={Boolean(open)}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <div
          className={open ? "station__hideicon" : "station__hideicon__rotated"}
        >
          <BsArrowBarLeft size="1.5em" strokeWidth="0.1" />
        </div>
      </motion.div>
      <Stations />
    </motion.div>
  );
}
